import { AxiosResponse } from 'axios';
import { FileDownload } from '../services/types';

export const getFile = (response: AxiosResponse<Blob>): FileDownload => {
  const blob = response.data;
  const name = response.headers['content-disposition']?.match(/.*filename=(.*)/)?.[1] || '';
  return { blob, name };
};
